import type { HelpFile } from '../../types/help'
import { CreatePartyTestIds } from '../../../testids/CreatePartyTestIds'

export const createPartyHelp: HelpFile = {
  docPage: '/docs/identity/parties',
  texts: {
    [CreatePartyTestIds.cardTitleCreateParty]:
      'Neue Partei vom festgelegten Typ anlegen. Pflichtattribute leiten sich aus den Attributdefinitionen des Typs und seiner Anzeigename-Vorlage ab.',
    [CreatePartyTestIds.btnCancelCreateParty]: null,
    [CreatePartyTestIds.btnSubmitCreateParty]: null,
  },
}
